export default "__VITE_PUBLIC_ASSET__87a2873d__"